import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { campaignsApi } from '../../api/campaigns';
import { queryKeys } from '../queryClient';
import type { CampaignInput } from '../../types/domain';

/** Campaign (promo code) management — manager+. */
export function useCampaigns() {
  return useQuery({ queryKey: queryKeys.campaigns, queryFn: () => campaignsApi.list() });
}

export function useCampaign(id: string | undefined) {
  return useQuery({
    queryKey: [...queryKeys.campaigns, id],
    queryFn: () => campaignsApi.get(id!),
    enabled: !!id,
  });
}

export function useCreateCampaign() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: CampaignInput) => campaignsApi.create(body),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.campaigns }),
  });
}

export function useUpdateCampaign() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: CampaignInput }) => campaignsApi.update(id, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.campaigns }),
  });
}

export function useDeleteCampaign() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => campaignsApi.remove(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.campaigns }),
  });
}
